module.exports = __webpack_public_path__ + "static/datamanPro-6244dfe3809890b0bb9f856722d6a1e7.png";